import { Component, OnInit } from '@angular/core';
import { BasketsFacade } from '@kion/data-access/data-access-baskets';
import { Observable } from 'rxjs';
import { Basket } from '@kion/data-models';
import { map } from 'rxjs/operators';
import { CmsConfig } from '../../../../../../cms/src/lib/config/cms.config';

@Component({
  selector: 'kion-mini-basket',
  templateUrl: './mini-basket.component.html',
  styleUrls: ['./mini-basket.component.scss']
})
export class MiniBasketComponent implements OnInit {

  basket$: Observable<Basket>;
  basketLink: string;

  constructor(private basketsFacade: BasketsFacade, private cmsConfig: CmsConfig) {
    this.basketLink = '/' + this.cmsConfig.routes?.basketBaseRoute
  }

  ngOnInit(): void {
    this.basket$ = this.basketsFacade.all$.pipe(
      map(
        (baskets: Basket[]) => baskets.find(
          (basket: Basket) => basket.id === window.localStorage.getItem('basketId')
        )
      )
    )
  }

}
